import { render } from "./HospitalManagement.vue?vue&type=template&id=220f5aba"
import script from "./HospitalManagement.vue?vue&type=script&lang=js"
export * from "./HospitalManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__